export const formatRole = (role) => {
  return role.replace(/_/g, ' ').replace(/\w\S*/g, (str) => {
    return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
  });
};
